import SearchHistoryPage from './SearchHistoryPage';

export default SearchHistoryPage;
